module.exports = {
  MAIL_SUBCLASS: 'MAIL_SUBCLASS',
  MAIL_CLASS: 'MAIL_CLASS',
  MAIL_CATEGORY: 'MAIL_CATEGORY',
};
